export enum AuthMethodEnum {
  login = 'login',
  sso = 'sso',
  invite = 'invite',
}
